import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import MovieCard from "./MovieCard";

export const Row = ({ title, movies, onCardClick, progressMap }) => {
  const ref = useRef(null);

  if (!movies?.length) return null;

  const scroll = (dir) => {
    if (!ref.current) return;
    ref.current.scrollBy({ left: dir * (ref.current.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section className="px-6 md:px-12 mt-12 md:mt-16 group/row" data-testid={`row-${title}`}>
      <div className="flex items-end justify-between mb-5">
        <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight text-white">
          {title}
        </h2>
        <div className="hidden md:flex items-center gap-2 opacity-0 group-hover/row:opacity-100 transition-opacity duration-300">
          <button
            onClick={() => scroll(-1)}
            className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-white/10 text-white transition-colors duration-300"
            aria-label="Scroll left"
            data-testid={`row-scroll-left-${title}`}
          >
            <ChevronLeft size={16} strokeWidth={1.5} />
          </button>
          <button
            onClick={() => scroll(1)}
            className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-white/10 text-white transition-colors duration-300"
            aria-label="Scroll right"
            data-testid={`row-scroll-right-${title}`}
          >
            <ChevronRight size={16} strokeWidth={1.5} />
          </button>
        </div>
      </div>
      <div ref={ref} className="flex items-stretch gap-3 md:gap-4 overflow-x-auto no-scrollbar pb-4 -mx-2 px-2">
        {movies.map((m) => (
          <MovieCard
            key={m.id}
            movie={m}
            progress={progressMap?.[m.id]}
            onClick={onCardClick}
          />
        ))}
      </div>
    </section>
  );
};

export default Row;
